import { connect } from "react-redux";
import LandlordSignUp from "../components/SignUp/Landlord";
import { clearSignUpStatus, setSignUpEmail } from "../actions/signUpActions";

function mapStateToProps( state ) {
    return {
        
    };
}

function mapDispatchToProps( dispatch ) {
    return {
        clearSignUp: () => dispatch( clearSignUpStatus() ),
        setEmail: ( email ) => dispatch( setSignUpEmail( email ) )
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( LandlordSignUp );